import { Trans } from '@exam-room/translations';
import { cn } from '@exam-room/utils';
import { useDisclosure } from '@shared/hooks';

import { WifiOffIcon } from '../../components';
import { useNetworkListener } from '../../providers';

export default function NetworkAlert() {
  const [isShown, { open, close }] = useDisclosure();

  useNetworkListener({
    onDisconnect: () => {
      open();
    },
    onReconnect: () => {
      close();
    },
  });

  return (
    <div className='z-50 w-full'>
      <div
        className={cn(
          'transition-[opacity,transform,height] duration-500 ease-in-out',
          isShown
            ? 'h-auto translate-y-0 opacity-100'
            : 'pointer-events-none h-0 -translate-y-4 overflow-hidden opacity-0',
        )}
      >
        <div
          className={cn(
            isShown && 'mb-6 px-4 py-3',
            'bg-danger-100 text-danger-900 flex items-center justify-between gap-3 rounded-lg',
          )}
        >
          <div className='flex items-center gap-3'>
            <WifiOffIcon className='text-danger shrink-0' />
            <div className='text-md font-normal'>
              <Trans
                i18nKey='examRoom.networkDisconnectedWarning'
                components={{
                  strong: <span className='font-semibold' />,
                }}
              />
            </div>
          </div>
          {/* <CloseRoundedIcon className='shrink-0 cursor-pointer text-gray-600' onClick={close} /> */}
        </div>
      </div>
    </div>
  );
}
